import { render, staticRenderFns } from "./opus-one.vue?vue&type=template&id=3195caf4&scoped=true"
import script from "./opus-one.vue?vue&type=script&lang=js"
export * from "./opus-one.vue?vue&type=script&lang=js"
import style0 from "./opus-one.vue?vue&type=style&index=0&id=3195caf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3195caf4",
  null
  
)

export default component.exports